import {
  ImageField,
  LinkField,
  StringField,
  ComponentProps,
  AttachmentLinkField,
  CheckboxField,
} from '../../../types/types';

export type ContactCardsField = {
  image?: ImageField
  CardImageDesktop?: ImageField 
  CTA?: LinkField
  description: StringField
  curriculum?: StringField
  curriculumTextModal?: StringField
  country?: StringField
  designation?: StringField
  download?: AttachmentLinkField
  SecondaryDownloadLink?: AttachmentLinkField
  SecondaryDownloadlinkText: StringField
  email?: LinkField
  emailText?: StringField
  fullname?: StringField
  mobile1?: StringField
  mobile2?: StringField
  ImageMobile?: ImageField
  primarylinktarget?: StringField
  secondarylinktarget?: StringField
  AllowFallbackForMobile?: CheckboxField
  TitleButtons?: StringField
  Variant?: StringField
  ColumnLayout?: ColumnLayout;
}

export type ColumnLayout = {
  fields: {
    Key: StringField;
  }
}

export interface ContactCardsFields {
  id?: string
  fields?: ContactCardsField
}

export type ContactCards = {
  ContactCardTitle: StringField
  ContactCardsLists: ContactCardsFields[]
  params: {}
  Variant?: StringField;
  ColumnLayout?: ColumnLayout;
}

export enum CardsLayout {
  '3ColumnLayout' = "3-columnLayout",
  '2ColumnLayout' = "2-columnLayout",
  '1ColumnLayout' = "1-columnLayout"
}

// export interface ContactCardTitle{
//   id?: string,
//   fields?:ContactCardTitle
// }

export interface ContactCardsProps extends ComponentProps<ContactCards, {}> {}
